(function() {
  "use strict";

  if (!customElements.get("mosaic-component")) {
    customElements.define("mosaic-component", class extends HTMLElement {
      constructor() {
        super();
        this.onResizeCallback = () => this.onResize();
        this.currentSlide = 0; // Track current slide
      }

      connectedCallback() {
        // Mobile slider check
        this.hasSliderMobile = this.hasAttribute("data-has-slider");
        this.hasSliderMobileDots = this.hasAttribute("data-has-slider-dots");

        // Elements
        this.carouselMobile = this.querySelector(".carousel--mobile");
        this.items = this.querySelectorAll("[data-item]");
        this.dotsContainer = this.querySelector(".mosaic__dots");
        
        console.log("Mosaic component initialized. this:", this);
        console.log("Mosaic component initialized. Mobile slider:", this.hasSliderMobile, "Items found:", this.items.length);
        console.log("Carousel mobile element:", this.carouselMobile);
        console.log("Dots container element:", this.dotsContainer);

        this.updateAOSAnchors();
        document.addEventListener("theme:resize:width", this.onResizeCallback);

        if (this.hasSliderMobile && this.items.length > 1) {
          this.initSlider();
        }
      }

      onResize() {
        this.updateAOSAnchors();
      }

      updateAOSAnchors() {
        if (
          theme.settings.animationsEnabled != "false" &&
          window.theme.isMobile() &&
          this.hasSliderMobile &&
          this.carouselMobile &&
          this.items.length > 1
        ) {
          const firstItem = this.items[0];
          const innerContent = firstItem.querySelector("[data-item-content-inner]");
          const firstItemId = firstItem.id;
          const innerId = innerContent ? innerContent.id : firstItemId;

          firstItem.setAttribute("data-aos-trigger", `#${firstItemId}`);
          if (innerContent) innerContent.setAttribute("data-aos-trigger", `#${innerId}`);

          this.items.forEach(item => {
            const aosElements = item.querySelectorAll("[data-aos], [data-aos-anchor]");
            const contentInner = item.querySelector("[data-item-content-inner]");

            item.setAttribute("data-aos-anchor", `#${firstItemId}`);
            if (contentInner) contentInner.setAttribute("data-aos-anchor", `#${innerId}`);

            aosElements.forEach(el => el.setAttribute("data-aos-anchor", `#${innerId}`));
          });
        }
      }

      initSlider() {
        // Create pagination dots
        if (this.dotsContainer) {
          this.dotsContainer.innerHTML = "";
          this.items.forEach((_, index) => {
            const dot = document.createElement("span");
            dot.className = "mosaic__dot";
            if (index === 0) dot.classList.add("active");
            dot.addEventListener("click", () => this.goToSlide(index));
            this.dotsContainer.appendChild(dot);
          });
        }

        // Detect scroll/swipe to update active dot
        this.carouselMobile.addEventListener("scroll", () => this.updateActiveDot());

        // Optional: touch swipe support for mobile
        let startX = 0;
        this.carouselMobile.addEventListener("touchstart", e => startX = e.touches[0].clientX);
        this.carouselMobile.addEventListener("touchend", e => {
          const endX = e.changedTouches[0].clientX;
          const threshold = 50; // Minimum swipe distance
          if (endX - startX > threshold) this.goToSlide(Math.max(0, this.currentSlide - 1));
          else if (startX - endX > threshold) this.goToSlide(Math.min(this.items.length - 1, this.currentSlide + 1));
        });
      }

      goToSlide(index) {
        this.currentSlide = index;
        const offset = this.items[index].offsetLeft;
        this.carouselMobile.scrollTo({ left: offset, behavior: "smooth" });

        // Update dots
        const dots = this.dotsContainer.querySelectorAll(".mosaic__dot");
        dots.forEach((dot, i) => dot.classList.toggle("active", i === index));
      }

      updateActiveDot() {
        // Find which slide is mostly visible
        const carouselScroll = this.carouselMobile.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.items.forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft - carouselScroll);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.currentSlide = closestIndex;

        if (this.dotsContainer) {
          const dots = this.dotsContainer.querySelectorAll(".mosaic__dot");
          dots.forEach((dot, i) => dot.classList.toggle("active", i === closestIndex));
        }
      }

      disconnectedCallback() {
        document.removeEventListener("theme:resize:width", this.onResizeCallback);
      }

    });
  }
})();
